import React from 'react';
import PropTypes from 'prop-types';
import { Components, Utils, translate } from 'versafleet-core';
import { connect } from 'react-redux';
import ReduxActions from 'reduxActions';
import queryString from 'query-string';
import withRouterHooks from 'utils/routerHelper';

class JobImportForm extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      file: '',
      error: [],
      form: {
        custom_field_group_id: props.account.default_custom_field_group_id,
      },
      isChanged: false,
    };
    this.basePath = 'jobs';
  }

  UNSAFE_componentWillMount() {
    this.props.dispatch(ReduxActions.customFieldGroup.fetchOptionCustomFieldGroupList());
  }

  _onFileChange(e) {
    this.setState({
      file: e.target.files[0] || '',
      error: [],
      isChanged: true,
    });
  }

  _onFormChange(fieldName, value) {
    this.setState(prevState => ({
      form: Utils.Helper.setFilter(prevState.form, fieldName, value),
      isChanged: true,
    }));
  }

  _reimport() {
    this.setState({ file: '', error: [] });
    this.props.navigate('/submissions/jobs/import');
  }

  async _import() {
    const { dispatch, strings } = this.props;
    const { file, form } = this.state;

    if (!Utils.Helper.isNullOrUndefined(file) && file.size > 10000000) {
      this.setState({ error: [strings.exceedSizeLimit] });
    } else {
      const formData = new FormData();
      formData.append('file', file);
      if (!Utils.Helper.isNullOrUndefined(form.custom_field_group_id)) {
        formData.append('custom_field_group_id', form.custom_field_group_id);
      }
      Utils.FullScreenLoading.FullScreenLoadingManager.open(strings.loadingJob);

      try {
        await dispatch(ReduxActions.job.importJobs(formData));
        this.props.navigate(`${Utils.Router.getPath()}?success=true`);
        this.setState({ isChanged: false });
      } catch (error) {
        this.setState({ error: Array.isArray(error) ? error : [error] });
      }

      Utils.FullScreenLoading.FullScreenLoadingManager.close();
    }
  }

  _downloadTemplate() {
    this.props.dispatch(ReduxActions.job.getImportTemplate({
      custom_field_group_id: this.state.form.custom_field_group_id || '',
    }));
  }

  _getOptions() {
    const { optionCustomFieldGroups } = this.props;

    const options = optionCustomFieldGroups.map(group => (
      {
        value: group.id,
        text: group.name,
      }
    ));

    options.unshift({
      value: null,
      text: this.props.strings.noCustomFieldGroup,
    });

    return options;
  }

  _renderMenu() {
    return (
      <Components.Form.Title>
        <Components.Form.Title.Item isHighlighted>
          {`${this.props.strings.import} ${Utils.Formatter.capitalizeFirstLetter(
            this.props.strings.basePath[this.basePath],
          )}`}
        </Components.Form.Title.Item>
      </Components.Form.Title>
    );
  }

  _renderCustomFieldGroupDropdown() {
    return (
      <Components.Form.Block>
        {this.props.strings.customFieldGroup}
        <Components.Form.Divider />

        <Components.Input.UntypableSelect
          id="vf-job__import-form__custom-field-group"
          onChange={value => this._onFormChange('custom_field_group_id', value)}
          options={this._getOptions()}
          value={this.state.form.custom_field_group_id}
        />
        <Components.Form.Divider size="MEDIUM" />
      </Components.Form.Block>
    );
  }

  _renderImportForm() {
    const { account, strings } = this.props;
    return (
      <div>
        <Components.Form.Block level={0}>
          {`${strings.import} ${Utils.Formatter.capitalizeFirstLetter(strings.basePath[this.basePath])}`}
        </Components.Form.Block>

        <Components.Form.Divider />

        <Components.Form.Block fontWeight="LIGHT" iconClassName="versa-attachment" level={0}>
          {
            this.state.file ? (
              <div className="vf-import-form__file-name">
                {this.state.file.name}
              </div>
            ) : (
              <div className="vf-import-form__file-placeholder">
                {strings.attachFile}
              </div>
            )
          }
          <input
            accept="text/csv, .csv, application/vnd.ms-excel, .xls, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, .xlsx"
            className="vf-import-form__file-input"
            id="vf-job__import-form__file-upload"
            onChange={this._onFileChange.bind(this)}
            type="file"
          />
        </Components.Form.Block>

        <Components.Form.Divider />

        <Components.Form.Block contentClassName="vf-import-form__description">
          {strings.acceptableExtensions}
        </Components.Form.Block>

        <Components.Form.Divider />

        <Components.Form.Block contentClassName="vf-import-form__error-message" level={1}>
          {this.state.error.join(', ')}
        </Components.Form.Block>

        <Components.Form.Divider />

        {!Utils.Helper.isNullOrUndefined(account.addons_setting)
          && account.addons_setting.custom_field ? this._renderCustomFieldGroupDropdown() : false}

        <Components.Form.Divider />

        <Components.Form.Block level={0}>
          {strings.referenceHelp}
          <a
            className="template"
            id="vf-job__import-form__download-template"
            onClick={this._downloadTemplate.bind(this)}
          >
            {strings.downloadTemplate}
          </a>
        </Components.Form.Block>
      </div>
    );
  }

  _renderSuccessMessage() {
    const { strings } = this.props;
    const replaceMap = {
      model: Utils.Formatter.capitalizeFirstLetter(strings.basePath[this.basePath]),
    };
    return (
      <div>
        <Components.Form.Block level={0}>
          {Utils.TranslationHelper.replaceTag(strings.importSuccess, replaceMap)}
        </Components.Form.Block>
        <Components.Form.Divider />
        <Components.Form.Block level={0}>
          <Components.Button
            id="vf-job__import-form__reimport-button"
            onClick={() => this._reimport()}
          >
            {strings.buttons.importAgain}
          </Components.Button>
        </Components.Form.Block>
      </div>
    );
  }

  _renderRightPanel() {
    return (
      <Components.Form.RightPanel>
        {queryString.parse(this.props.location.search).success !== 'true'
          ? (
            <Components.Form.MainButton id="vf-job__import-form__import-button" onClick={() => this._import()}>
              {`${this.props.strings.import} ${Utils.Formatter.capitalizeFirstLetter(
                this.props.strings.basePath[this.basePath],
              )}`}
            </Components.Form.MainButton>
          ) : false}
      </Components.Form.RightPanel>
    );
  }

  render() {
    return (
      <Components.Form.CoreLayout
        isChanged={this.state.isChanged}
        onClose={() => (this.props.location.pathname.includes('submissions')
          ? this.props.navigate('/submissions')
          : this.props.navigate('/in_progress'))}
        rightPanel={this._renderRightPanel()}
        title={this._renderMenu()}
      >
        {queryString.parse(this.props.location.search).success === 'true'
          ? this._renderSuccessMessage()
          : this._renderImportForm()}
        <Components.Form.Divider size="LARGE" />
        <Components.Form.Divider size="LARGE" />
        <Components.Form.Divider size="LARGE" />
      </Components.Form.CoreLayout>
    );
  }
}

JobImportForm.propTypes = {
  account: PropTypes.shape({
    addons_setting: PropTypes.shape({
      custom_field: PropTypes.number,
    }),
    default_custom_field_group_id: PropTypes.number,
  }).isRequired,
  dispatch: PropTypes.func.isRequired,
  location: PropTypes.shape({
    pathname: PropTypes.string,
    search: PropTypes.string,
  }).isRequired,
  match: PropTypes.shape({
    url: PropTypes.string,
  }).isRequired,
  navigate: PropTypes.func.isRequired,
  optionCustomFieldGroups: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  strings: PropTypes.shape({
    import: PropTypes.string,
    basePath: PropTypes.shape(),
    buttons: PropTypes.shape({
      importAgain: PropTypes.string,
    }),
    attachFile: PropTypes.string,
    acceptableExtensions: PropTypes.string,
    referenceHelp: PropTypes.string,
    downloadTemplate: PropTypes.string,
    importSuccess: PropTypes.string,
    customFieldGroup: PropTypes.string,
    noCustomFieldGroup: PropTypes.string,
    loadingJob: PropTypes.string,
    exceedSizeLimit: PropTypes.string,
  }).isRequired,
};

function mapStateToProps(state) {
  const { account, customFieldGroup } = state;
  return {
    account: account.account || {},
    optionCustomFieldGroups: customFieldGroup.optionCustomFieldGroups,
  };
}

export default withRouterHooks(connect(mapStateToProps)(translate('ImportForm')(JobImportForm)));
